export * from './contact-edition';
export * from './registration-student';
export * from './registration-contact.component';



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/index.ts